import { useTranslation } from 'react-i18next';
import WarningTriangleIcon from 'assets/icons/warning-triangle.svg?react';
import s from './AccountAlreadyExists.module.scss';

type Props = {
  onClick: () => void;
};

function AccountAlreadyExistsBox({ onClick }: Props) {
  const { t } = useTranslation('personal_details');
  return (
    <div className={s.box}>
      <div className={s.icon}>
        <WarningTriangleIcon />
      </div>
      <div className={s.body}>
        <div
          className={s.text}
          dangerouslySetInnerHTML={{ __html: t('already_exists.text') }}
        />
        <button className={s.button} type="button" onClick={onClick}>
          {t('already_exists.button')}
        </button>
      </div>
    </div>
  );
}

export default AccountAlreadyExistsBox;
